export enum AssetType {
  /** Regular spot asset (collateral) */
  Spot = 0,
  /** Derivatives / futures position */
  Position = 1,
}

export enum PositionType {
  Long = 0,
  Short = 1,
}
